// Results held by what they were worked out from, so asking again for the same thing can show them without working them
// out again. Only the latest are kept
export class HeldResults<T> {
    private held = new Map<string, { value: T, at: Date }>();

    constructor(private readonly size = 10) {}

    get(key: string) {
        return this.held.get(key);
    }

    set(key: string, value: T, at = new Date()) {
        // the latest last, so the oldest goes first when there are too many
        this.held.delete(key);
        this.held.set(key, { value, at });
        while (this.held.size > this.size) this.held.delete(this.held.keys().next().value!);
        return { value, at };
    }
}
